import React from 'react';
import Marquee from "react-fast-marquee";

const Logos = () => {
  const logos = [
    '/assets/img/Amazon_logo.png',
    '/assets/img/Infosys_logo.png',
    '/assets/img/Oracle_logo.png',
    '/assets/img/ibm-logo.png',
    '/assets/img/TCS-logo.png'
  ];

  return (
    <section className="py-12 bg-white border-b border-gray-100 overflow-hidden">
      <div className="container mx-auto px-4 text-center">
        <p className="text-sm font-semibold text-gray-400 uppercase tracking-widest mb-10">
          Trusted by Industry Leaders
        </p>
        
        <div className="relative w-full max-w-6xl mx-auto">
          {/* Gradient Masks */}
          <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-white to-transparent z-10"></div>

          <Marquee 
            gradient={false} 
            speed={40} 
            pauseOnHover={true}
            className="flex items-center"
          >
            {/* Duplicated set for seamless loop - handled by marquee but added for length */}
            {[...logos, ...logos, ...logos].map((logo, index) => (
              <div key={index} className="mx-12 opacity-50 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0">
                <img 
                  src={logo} 
                  alt="Partner Logo" 
                  className="h-8 md:h-12 w-auto object-contain"
                />
              </div>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};

export default Logos;
